// extracted by mini-css-extract-plugin
export default {"recommended_actions":"dashboardGraphPopup_recommended_actions__FBDlH","graph_summary":"dashboardGraphPopup_graph_summary__ZLJ3n"};